import Reviews from '../components/Reviews';

export default function AllReviews() {
  return (
    <div style={{ paddingTop: 68 }}>
      <Reviews showAll={true} />
    </div>
  );
}
